import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public title = 'app';
}



// WEBPACK FOOTER //
// D:/01.Developer/0.Web/Bravo8-Base/src/app/app.component.ts